import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';


@Component({
  selector: 'app-ticket-type',
  templateUrl: './ticket-type.component.html',
  styleUrls: ['./ticket-type.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TicketTypeComponent,
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: TicketTypeComponent
    }
  ]
})
export class TicketTypeComponent implements ControlValueAccessor, Validator {

  onTouched: Function = () => {};
  onChange: Function = () => {};
  disabled!: boolean;
  textColor!: string;
  color!: string;


  // @Input() value;
  @Input() type: any;
  @Input() price: any;
  @Output() numDayChange = new EventEmitter<number>();

  private active!: boolean;
  set isActive(value: boolean) {
    this.active = value;
    if (this.active) {
      this.textColor = "#e5b000";
      this.color = "#1b8e78";
    } else {
      this.textColor = "#C9C9C9";
      this.color = "#C9C9C9";
    }
  }

  get isActive(): boolean {
    return this.active;
  }

  static nextId: number = 0;

  inputId;

  constructor() {
    this.inputId = ++TicketTypeComponent.nextId;
  }

  @HostListener('click')
  onSelect() {
    this.onTouched();
    this.onChange(this.type);
    this.numDayChange.emit(this.type);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  writeValue(obj: any): void {
    this.isActive = obj == this.type;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.isActive = control.value == this.type;
    return null;
  }

}
